import { styled, TextField } from '@mui/material';
import { StyledSubmitInputByIdProps } from './types';

export const StyledSubmitInputById = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'isLoading',
})<StyledSubmitInputByIdProps>`
  color: ${({ isLoading }) => (isLoading ? '#C0C7CA' : '')};
  align-items: center;

  & .MuiInputBase-root {
    padding: 0;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;
